import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef48ba3e&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ef48ba3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef48ba3e",
  null
  
)

export default component.exports